// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 154) return "js/154.bundle.js";
	if (chunkId === 899) return "js/payment.bundle.js";
	if (chunkId === 76) return "js/common.bundle.js";
	if (chunkId === 148) return "js/SystemAdjustments.bundle.js";
	if (chunkId === 95) return "js/loyalty-customers.bundle.js";
	if (chunkId === 732) return "js/ViewClosedTicket.bundle.js";
	if (chunkId === 836) return "js/TicketDetail.bundle.js";
	if (chunkId === 351) return "js/float.bundle.js";
	if (chunkId === 197) return "js/cashup.bundle.js";
	if (chunkId === 864) return "js/cashup-records.bundle.js";
	if (chunkId === 693) return "js/salesRecords.bundle.js";
	if (chunkId === 472) return "js/settings.bundle.js";
	if (chunkId === 526) return "js/viewInvoice.bundle.js";
	if (chunkId === 426) return "js/refundInvoice.bundle.js";
	if (chunkId === 965) return "js/kitchen-orders.bundle.js";
	if (chunkId === 636) return "js/create-table.bundle.js";
	if (chunkId === 220) return "js/create-debtor.bundle.js";
	if (chunkId === 733) return "js/subscription-accounts.bundle.js";
	if (chunkId === 393) return "js/merge-tables.bundle.js";
	if (chunkId === 866) return "js/split-table.bundle.js";
	if (chunkId === 689) return "js/stock-take.bundle.js";
	if (chunkId === 145) return "js/run-stock-take.bundle.js";
	if (chunkId === 481) return "js/stock-transfer.bundle.js";
	if (chunkId === 741) return "js/offline-invoices.bundle.js";
	if (chunkId === 500) return "js/online-orders.bundle.js";
	if (chunkId === 22) return "js/help.bundle.js";
	if (chunkId === 531) return "js/updates-view.bundle.js";
	if (chunkId === 609) return "js/email-settings.bundle.js";
	if (chunkId === 94) return "js/Login.bundle.js";
	if (chunkId === 930) return "js/setup.bundle.js";
	if (chunkId === 376) return "js/system-expired.bundle.js";
	if (chunkId === 480) return "js/make-subscription-payment.bundle.js";
	if (chunkId === 382) return "js/expire-extension.bundle.js";
	if (chunkId === 62) return "js/validation.bundle.js";
	if (chunkId === 247) return "js/payment-view.bundle.js";
	if (chunkId === 66) return "js/66.bundle.js";
	if (chunkId === 126) return "js/table-session-gate.bundle.js";
	// return url for filenames based on template
	return undefined;
};